import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const names = {
    A: "A",
    B: "B",
    C: "C",
    D: "D",
    E: "E",
    F: "F",
    G: "G"
};

export const EnergieLabelFilter = ({ condensed }) => {
    const filter = useFilter("energielabel");

    const [value, , onChange] = useField("energielabel");
    const allValues = filter && filter.length ? filter : Object.values(names);

    const options = allValues.map((o) => ({
        id: o,
        naam: names[o] || o.toLowerCase()
    }));

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-energielabel"
                datalayerKey="energielabel"
                options={options}
                value={value}
                handleChange={(_, selection) => onChange(selection)}
                columns={condensed ? 2 : 7}
                condensed
            />
            <Empty />
        </Grid>
    );
};
